"use client";

import Fuse from "fuse.js";
import { useMemo } from "react";

import { NoArtistInstrumentModelMixedModel } from "@/components/selectArtistModal/NoArtistInstrumentModelMixedModel";
import { VoiceGrid } from "@/components/selectArtistModal/VoiceGrid";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import { ArtistInstumentSaved, ModelNoDates, UserNoDates } from "@/types/types";

export function MyTab({
  confirmedDoneModels,
  handleClickArtist,
  closeModal,
  user,
  savedArtistsInstrumentsIds,
  namespace,
}: {
  confirmedDoneModels: ModelNoDates[] | null;
  handleClickArtist: (artistId: string) => void;
  closeModal: () => void;
  user: UserNoDates | null;
  savedArtistsInstrumentsIds: ArtistInstumentSaved["artistInstrumentId"][];
  namespace: string;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const searchString = useSelectArtistFilters((state) => state.searchString);

  const noModels =
    confirmedDoneModels === null || confirmedDoneModels.length === 0;

  if (noModels) {
    return <NoArtistInstrumentModelMixedModel text="No voices created." />;
  }

  const fuse = useMemo(
    () =>
      new Fuse(confirmedDoneModels, {
        includeScore: false,
        isCaseSensitive: false,
        keys: ["name"],
        threshold: 0.1,
      }),
    [confirmedDoneModels]
  );

  // Filter models based on search
  const filteredModels =
    searchString !== "" ?
      fuse.search(searchString).map((result) => result.item)
    : confirmedDoneModels;

  const noFilteredModels = filteredModels.length === 0;

  return noFilteredModels ?
      <NoArtistInstrumentModelMixedModel text="No voices found. Try changing your search term." />
    : <VoiceGrid
        voices={filteredModels}
        handleClickArtist={(artistId) => {
          handleClickArtist(artistId);
          closeModal();
        }}
        user={user}
        savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
      />;
}
